module.exports = __webpack_public_path__ + "static/media/dog.54a68beb.svg";